import React from "react";

interface DividerSectionProps {
  imageUrl: string;
  height?: string; // Höhe der Section, z. B. "300px", "50vh"
}

const DividerSection: React.FunctionComponent<DividerSectionProps> = ({
  imageUrl,
  height = "35vh"
}) => {
  const sectionStyle: React.CSSProperties = {
    display: "block",
    overflow: "hidden",
    marginBottom: "50vh",
  };

  const wrapperStyle: React.CSSProperties = {
    position: "absolute",
    left: 0,
    right: 0,
    height: height,
    width: "100%",
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    overflow: "hidden",
  };

  const skewTopStyle: React.CSSProperties = {
    position: "absolute",
    top: `calc(${height} / 1.842)`,
    left: 0,
    width: "100%",
    height: height,
    backgroundColor: "white", // Farbe des Bereichs davor
    transform: "skewY(3deg)",
    transformOrigin: "bottom left",
  };

  const skewBottomStyle: React.CSSProperties = {
    position: "absolute",
    bottom: height,
    left: 0,
    width: "100%",
    height: height,
    backgroundColor: "white", // Farbe des Bereichs danach
    transform: "skewY(3deg)",
    transformOrigin: "top left",
  };

  return (
    <section style={sectionStyle}>
      <div style={wrapperStyle}>
      <div style={skewTopStyle}></div>
      <div style={skewBottomStyle}></div>
      </div>
    </section>
  );
};

export default DividerSection;